document.addEventListener('DOMContentLoaded', () => {
  const grid = document.querySelector('[data-kk-ateliers-grid]');

  if (!grid) return;

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const getDate = (card) => {
    const value = card.dataset.atelierDate;
    if (!value) return null;

    const date = new Date(`${value}T00:00:00`);
    return Number.isNaN(date.getTime()) ? null : date;
  };

  const cards = Array.from(grid.querySelectorAll('[data-atelier-date], .kk-ateliers-card:not([data-atelier-date])'));

  cards
    .sort((firstCard, secondCard) => {
      const firstDate = getDate(firstCard);
      const secondDate = getDate(secondCard);

      if (!firstDate) return 1;
      if (!secondDate) return -1;

      const firstIsPast = firstDate < today;
      const secondIsPast = secondDate < today;

      if (firstIsPast !== secondIsPast) return firstIsPast ? 1 : -1;

      return firstIsPast ? secondDate - firstDate : firstDate - secondDate;
    })
    .forEach((card) => grid.append(card));
});
